import { useTranslation } from 'react-i18next';
import { Form, MenuItem } from 'bonfire-kindling';

import { PROJECT_VIEW_STATUS } from 'constants/opportunities';

const SavedSearchSettingsUpsertViewed = () => {
  const { t } = useTranslation();

  return (
    <Form.SelectField
      label={t('settings.saved_search.edit_or_create.viewed_title')}
      name="viewedProjects"
      fullWidth
    >
      <MenuItem
        value={PROJECT_VIEW_STATUS.allStatuses}
        label={t('settings.saved_search.edit_or_create.viewed_option_all')}
      />
      <MenuItem
        value={PROJECT_VIEW_STATUS.viewed}
        label={t('settings.saved_search.edit_or_create.viewed_option_viewed')}
      />
      <MenuItem
        value={PROJECT_VIEW_STATUS.notViewed}
        label={t('settings.saved_search.edit_or_create.viewed_option_not_viewed')}
      />
    </Form.SelectField>
  );
};

export default SavedSearchSettingsUpsertViewed;
